import React from 'react';
import { Button, Card, CardContent, IconButton } from "@mui/material";
import { Delete, Plus } from "lucide-react";

const labels = {
    expenses: 'Расходы',
    income: 'Доходы',
    goals: 'Цели'
};

const SettingsPage = ({ categories, deleteCategory, setDialogs }) => {
    return (
        <div className="max-w-6xl mx-auto space-y-6">
            <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
                <div>
                    <p className="text-xs uppercase tracking-[0.22em] text-teal-300/80">Справочники</p>
                    <h2 className="panel-title mt-2 text-3xl font-bold">Настройки</h2>
                </div>
                <Button
                    variant="contained"
                    startIcon={<Plus />}
                    onClick={() => setDialogs(prev => ({ ...prev, category: true }))}
                    sx={{ minHeight: 46 }}
                >
                    Добавить категорию
                </Button>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                {Object.entries(categories).map(([type, cats]) => (
                    <section key={type} className="space-y-3">
                        <div className="flex items-center justify-between">
                            <h3 className="text-lg font-semibold text-white">{labels[type]}</h3>
                            <span className="text-sm text-slate-400">{cats.length}</span>
                        </div>
                        {cats.map(cat => (
                            <Card key={cat.id} elevation={0}>
                                <CardContent>
                                    <div className="flex items-center justify-between gap-3">
                                        <div className="min-w-0">
                                            <p className="truncate font-semibold text-white">{cat.name}</p>
                                            {cat.limit && <p className="muted-label text-sm">{cat.limit.toLocaleString()} ₽</p>}
                                            {cat.target && <p className="muted-label text-sm">{cat.current.toLocaleString()} ₽ из {cat.target.toLocaleString()} ₽</p>}
                                        </div>
                                        <IconButton
                                            size="small"
                                            onClick={() => deleteCategory(type, cat.id)}
                                            sx={{ color: '#fb7185' }}
                                        >
                                            <Delete size={18} />
                                        </IconButton>
                                    </div>
                                </CardContent>
                            </Card>
                        ))}
                    </section>
                ))}
            </div>
        </div>
    );
};

export default SettingsPage;
